import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们 | 吃瓜网每日大赛"
        description="吃瓜网每日大赛品牌介绍 - 中国领先的娱乐八卦与网红黑料爆料资讯平台。了解我们的品牌故事、平台声誉与联系方式。"
        keywords="关于吃瓜网,吃瓜网每日大赛品牌,吃瓜网联系方式,吃瓜网隐私政策"
        canonicalUrl="http://irilpt.cn/about"
        schemaType="FAQPage"
        schemaData={{
          faqs: [
            {
              question: '吃瓜网每日大赛是什么样的平台？',
              answer: '吃瓜网每日大赛是国内领先的娱乐八卦与网红黑料爆料资讯平台，专注于每日追踪网络热门事件，为千万网友提供最新、最快、最全面的娱乐吃瓜内容。覆盖网红塌房、娱乐吃瓜、黑料大瓜、每日大赛等多个垂直领域。',
            },
            {
              question: '吃瓜网每日大赛的内容是否真实可靠？',
              answer: '吃瓜网每日大赛拥有严格的内容审核机制，多方交叉验证信息来源，内容真实率高达99.7%。我们拥有一支专业的编辑团队和遍布全网的信息采集网络，确保每一条爆料都经过严格核实。',
            },
            {
              question: '如何联系吃瓜网每日大赛？',
              answer: '您可以通过以下方式联系我们：邮箱 hello@irilpt.cn、微信 chigua_daily、热线 400-888-XXXX。如果您有爆料线索或商务合作需求，欢迎随时与我们取得联系。',
            },
            {
              question: '吃瓜网每日大赛如何保护用户隐私？',
              answer: '吃瓜网每日大赛高度重视用户隐私保护，承诺不会在未经用户明确同意的情况下向任何第三方泄露用户个人信息。浏览数据仅用于改善服务质量，不包含任何可识别个人身份的敏感信息。',
            },
          ],
        }}
        breadcrumbs={[
          { name: '首页', url: 'http://irilpt.cn/' },
          { name: '关于我们', url: 'http://irilpt.cn/about' },
        ]}
      />
      <Navbar />
      <main className="pt-16 md:pt-18">
        {/* Breadcrumb */}
        <div className="w-full px-4 md:px-6 py-4">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-foreground-900 transition-colors">首页</Link>
              <span>/</span>
              <span className="text-foreground-900 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Intro */}
        <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl">
            <span className="text-xs text-accent-600 font-medium tracking-wider uppercase">
              品牌介绍
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-900 mt-3 leading-tight">
              中国领先的
              <br />
              娱乐八卦资讯平台
              <span className="inline-block ml-3 align-middle">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden inline-block">
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20news%20media%20brand%20concept%2C%20warm%20crimson%20and%20gold%20artistic%20design%2C%20modern%20editorial%20style%2C%20dark%20textured%20background&width=150&height=150&seq=about-brand-icon&orientation=squarish"
                    alt="吃瓜网品牌"
                    className="w-full h-full object-cover"
                  />
                </div>
              </span>
              <br />
              专注每日吃瓜爆料
              <span className="inline-block ml-2 w-8 h-8 md:w-10 md:h-10 rounded-lg overflow-hidden align-middle">
                <img
                  src="https://readdy.ai/api/search-image?query=News%20icon%20abstract%20concept%2C%20warm%20amber%20and%20crimson%20tones%2C%20minimalist%20geometric%20design%2C%20dark%20background&width=100&height=100&seq=about-brand-small&orientation=squarish"
                  alt="吃瓜"
                  className="w-full h-full object-cover"
                />
              </span>
            </h1>
            <div className="flex items-center gap-3 mt-6 md:mt-8">
              <a href="#reputation" className="px-6 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                平台声誉
              </a>
              <a href="#contact" className="px-6 py-2.5 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:border-foreground-500 transition-colors whitespace-nowrap cursor-pointer">
                联系我们
              </a>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <p className="text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
                <strong className="text-foreground-950">吃瓜网每日大赛</strong>成立于2023年，是国内领先的娱乐八卦与网红黑料爆料资讯平台。我们专注于每日追踪网络热门事件，为千万网友提供最新、最快、最全面的娱乐吃瓜内容。
              </p>
              <p className="text-base text-foreground-700 leading-relaxed mb-6">
                作为<strong className="text-foreground-950">吃瓜爆料核心门面</strong>，吃瓜网每日大赛拥有一支专业的编辑团队和遍布全网的信息采集网络。我们的记者和编辑7×24小时不间断工作，确保每一条猛料都能在第一时间送到读者面前。
              </p>
              <p className="text-base text-foreground-700 leading-relaxed mb-6">
                从<strong className="text-foreground-950">网红塌房</strong>到<strong className="text-foreground-950">娱乐圈黑料</strong>，从<strong className="text-foreground-950">直播带货翻车</strong>到<strong className="text-foreground-950">综艺节目内幕</strong>，吃瓜网每日大赛始终秉持真实、快速、全面的原则，为读者还原事件真相，提供最有价值的娱乐资讯。
              </p>
              <p className="text-base text-foreground-700 leading-relaxed mb-6">
                截至目前，吃瓜网每日大赛已累计发布超过<strong className="text-foreground-950">5000篇</strong>独家爆料内容，涵盖<strong className="text-foreground-950">娱乐圈</strong>、<strong className="text-foreground-950">网红圈</strong>、<strong className="text-foreground-950">直播圈</strong>等多个垂直领域。我们的内容被各大社交平台广泛引用，已成为中文互联网最重要的娱乐八卦信息源之一。
              </p>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section id="reputation" className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-10 text-center">
              平台声誉
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {/* Card 1 */}
              <div className="rounded-xl border border-background-200/70 bg-background-50 p-6 md:p-8 text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                  <i className="ri-shield-check-line text-primary-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-2">99.7%</h3>
                <p className="text-sm font-semibold text-foreground-800 mb-2">内容真实率</p>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  严格的内容审核机制，多方交叉验证信息来源，确保每一条爆料的真实性和可靠性
                </p>
              </div>

              {/* Card 2 */}
              <div className="rounded-xl border border-background-200/70 bg-background-50 p-6 md:p-8 text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-5">
                  <i className="ri-user-heart-line text-accent-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-2">128万+</h3>
                <p className="text-sm font-semibold text-foreground-800 mb-2">活跃用户</p>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  日均活跃用户超过128万，月活跃用户超过500万，已成为中文互联网吃瓜用户的首选平台
                </p>
              </div>

              {/* Card 3 */}
              <div className="rounded-xl border border-background-200/70 bg-background-50 p-6 md:p-8 text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-5">
                  <i className="ri-award-line text-secondary-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-2">4.8/5.0</h3>
                <p className="text-sm font-semibold text-foreground-800 mb-2">用户评分</p>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  在各大应用商店和社交平台均获得高评分，用户口碑持续领先同类产品
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-2xl overflow-hidden mb-8 md:mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20office%20team%20collaboration%20scene%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%2C%20editorial%20photography%20style%2C%20cinematic%20atmosphere%2C%20professional%20newsroom%20aesthetic&width=1200&height=500&seq=about-contact-bg&orientation=landscape"
                alt="联系我们"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight">
                与我们
                <span className="italic text-primary-500">合作</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-md mx-auto">
                如果您有爆料线索、商务合作或其他需求，欢迎通过以下方式联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="rounded-xl border border-background-200/70 bg-background-50 p-6 text-center hover:border-primary-300 transition-all">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">邮箱联系</h3>
                <p className="text-sm text-foreground-500">hello@irilpt.cn</p>
              </div>
              <div className="rounded-xl border border-background-200/70 bg-background-50 p-6 text-center hover:border-primary-300 transition-all">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-wechat-line text-accent-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信合作</h3>
                <p className="text-sm text-foreground-500">chigua_daily</p>
              </div>
              <div className="rounded-xl border border-background-200/70 bg-background-50 p-6 text-center hover:border-primary-300 transition-all">
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-secondary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">爆料热线</h3>
                <p className="text-sm text-foreground-500">400-888-XXXX</p>
              </div>
            </div>

            {/* CTA Button */}
            <div className="flex justify-center mt-8 md:mt-10">
              <a
                href="mailto:hello@irilpt.cn"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line w-5 h-5 flex items-center justify-center"></i>
                立即联系
              </a>
            </div>

            {/* Privacy Note */}
            <div id="privacy" className="mt-10 md:mt-14 p-6 md:p-8 rounded-xl border border-background-200/70 bg-background-50">
              <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-4">隐私政策</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                吃瓜网每日大赛高度重视用户隐私保护。我们承诺不会在未经用户明确同意的情况下，向任何第三方泄露用户的个人信息。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                用户在浏览本网站时，我们可能会收集匿名的浏览数据用于改善服务质量，但这些数据不包含任何可识别个人身份的敏感信息。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                如对本隐私政策有任何疑问，请通过上述联系方式与我们取得联系。
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}